module.exports = __webpack_public_path__ + "static/00015.85adb9d4.jpg";